// vue-toasted gan message dang chuoi bang innerHTML, nen chu tu BE/nguon ngoai co the chay nhu HTML.
// Ham nay doi message thanh chuoi da escape, giu dung chu hien thi nhu innerHTML cu:
// - HTMLElement: tra nguyen (thu vien appendChild, khong qua innerHTML).
// - null -> "" va con lai String(message) (undefined -> "undefined", Error -> "Error: ...", mang -> "a,b").
const HTML_ESCAPES = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

const isHtmlElement = (value) =>
  value !== null &&
  typeof value === "object" &&
  value.nodeType === 1 &&
  typeof value.nodeName === "string";

export const toToastText = (message) => {
  if (isHtmlElement(message)) return message;
  const text = message === null ? "" : String(message);
  return text.replace(/[&<>"']/g, (ch) => HTML_ESCAPES[ch]);
};
